let wyrdLoyaltyRepairFrameV37 = 0;

function wyrdRepairLoyaltyRootV37(root) {
  const mobile = window.matchMedia('(max-width: 760px)').matches;

  root
    .querySelectorAll('.lion-loyalty-splash--format-modal')
    .forEach((splash) => {
      const heading = splash.querySelector('.lion-loyalty-splash__heading');
      if (!heading) return;

      const welcomeTitle = heading.querySelector(
        '.lion-loyalty-splash__title--welcome'
      );
      const primaryTitle = heading.querySelector(
        '.lion-loyalty-splash__title:not(.lion-loyalty-splash__title--welcome)'
      );

      if (welcomeTitle) {
        if (welcomeTitle.getAttribute('aria-hidden') !== 'true') {
          welcomeTitle.setAttribute('aria-hidden', 'true');
        }
        if (
          welcomeTitle.style.getPropertyValue('display') !== 'none' ||
          welcomeTitle.style.getPropertyPriority('display') !== 'important'
        ) {
          welcomeTitle.style.setProperty('display', 'none', 'important');
        }
      }

      if (
        mobile &&
        primaryTitle &&
        (primaryTitle.style.getPropertyValue('display') !== 'block' ||
          primaryTitle.style.getPropertyPriority('display') !== 'important')
      ) {
        primaryTitle.style.setProperty('display', 'block', 'important');
      }
    });

  const visitLabel = document.body.dataset.wyrdLoyaltyVisitLabel;
  if (!visitLabel) return;

  root
    .querySelectorAll(
      '.lion-loyalty-splash-item--rule .lion-loyalty-splash-item__title'
    )
    .forEach((title) => {
      if (title.textContent.replace(/\s+/g, ' ').trim() === 'Visit') {
        title.textContent = visitLabel;
      }
    });
}

function wyrdRepairLoyaltyV37() {
  document
    .querySelectorAll('#loyaltylion')
    .forEach(wyrdRepairLoyaltyRootV37);
}

function wyrdScheduleLoyaltyRepairV37() {
  if (wyrdLoyaltyRepairFrameV37) return;

  wyrdLoyaltyRepairFrameV37 = window.requestAnimationFrame(() => {
    wyrdLoyaltyRepairFrameV37 = 0;
    wyrdRepairLoyaltyV37();
  });
}

new MutationObserver(wyrdScheduleLoyaltyRepairV37).observe(
  document.documentElement,
  {
    childList: true,
    subtree: true
  }
);

window.addEventListener('pageshow', wyrdScheduleLoyaltyRepairV37);
window.addEventListener('resize', wyrdScheduleLoyaltyRepairV37, {
  passive: true
});

wyrdScheduleLoyaltyRepairV37();
